import React, { useRef } from "react";
import cn from "classnames";
import { twMerge } from "tailwind-merge";
import { Icon } from "../Icon/Icon";
import { HeadlessUi } from "../headlessUi";
import classNames from "classnames";
const colorClasses = {
    main: "bg-main-color",
    gray: "bg-icon-in-input-color",
    red: "bg-delete-color",
    darkMedical: "bg-surface-medical-dark-color",
};
const Checkbox = ({ id, className, children, onChange, indeterminate = false, style, disabled, checked, color = "main", childrenWrapperClassName, }) => {
    const inputRef = useRef(null);
    const handleChange = (value) => {
        if (indeterminate) {
            onChange(true);
        }
        else {
            onChange(value);
        }
    };
    const bgColorClass = colorClasses[color];
    return (React.createElement(HeadlessUi.Field, { className: twMerge("flex w-fit items-center gap-2", className) },
        React.createElement(HeadlessUi.Checkbox, { id: id, checked: checked, disabled: disabled, onChange: handleChange, ref: inputRef, className: twMerge("box-border flex h-6 w-6 items-center justify-center", "rounded-[4px] border border-solid border-separator-color bg-on-main-color", "flex-shrink-0 shadow-small_element", "transition-all duration-200", disabled ? "cursor-not-allowed" : "cursor-pointer", checked && !indeterminate && `${bgColorClass} border-transparent`, indeterminate && `${bgColorClass} opacity-60`, !checked &&
                !disabled &&
                !indeterminate &&
                "shadow-inner hover:bg-separator-color") },
            indeterminate && (React.createElement("div", { className: "flex h-full items-center justify-center" },
                React.createElement(Icon, { className: classNames(`icon partial-icon icon-sm m-auto overflow-hidden bg-on-main-color   `) }))),
            checked && !indeterminate && (React.createElement("div", { className: "flex h-full items-center justify-center" },
                React.createElement(Icon, { className: classNames(`icon check-in-object-icon icon-sm m-auto overflow-hidden  bg-on-main-color`) })))),
        children && (React.createElement(HeadlessUi.Label, { style: style, className: cn("typography-main text-text-color", disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer", childrenWrapperClassName) }, children))));
};
export default Checkbox;
//# sourceMappingURL=Checkbox.js.map